/* eslint-disable */
import React from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import person from '../../../../../../assets/cybersecurity2026/topic900/section3-img1.png';
import personIcon1 from '../../../../../../assets/education/topic900/priority_icon1.png';
import personIcon2 from '../../../../../../assets/education/topic900/priority_icon2.png';
import personIcon3 from '../../../../../../assets/education/topic900/priority_icon3.svg';
import arrow from '../../../../../../assets/cybersecurity2026/finger.gif';
import section3Img1 from '../../../../../../assets/cybersecurity2026/topic900/section3-img1.png';
import section3Img2 from '../../../../../../assets/cybersecurity2026/topic900/section3-img2.png';

import section3Icon1 from '../../../../../../assets/cybersecurity2026/topic900/section3-icon1.png';
import section3Icon2 from '../../../../../../assets/cybersecurity2026/topic900/section3-icon2.png';

interface ISection2Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const iconMap: any = {
    1: section3Icon1,
    2: section3Icon2,
  };
  // 新增：跟踪元素是否已经进入过视口
  // const [hasEntered, setHasEntered] = React.useState(false);
  // 添加步骤状态
  const [currentStep, setCurrentStep] = React.useState(1);

  const [active, setActive] = React.useState(1);
  const [switchTab, setSwitchTab] = React.useState(false);
  const updateComponentState = useUpdateComponentState();

  const [visible, setVisible] = React.useState(2);
  const [animationStarted1, setAnimationStarted1] = React.useState(false); // 控制动画是否已开始
  // const { updateParagraphState } = useStore();
  const personIcon: any = {
    personIcon1,
    personIcon2,
    personIcon3,
  };

  React.useEffect(() => {
    if (!animationStarted1) return;
    setAnimationStarted1(true);
    if (visible >= paragraphsSettings.l2List?.length) return;
    const timer = setTimeout(() => setVisible((v) => v + 1), 400);
    return () => clearTimeout(timer);
  }, [visible, paragraphsSettings.l2List?.length]);

  const [state, setState] = React.useState({
    clickSlide: 2,
    state1: false,
    quiz: false,
    deepfakeFlagLeft: false,
    deepfakeFlagRight: false,
  });

  // 新增：跟踪所有选中的条目ID数组
  const [selectedItemIds, setSelectedItemIds] = React.useState<number[]>([]);

  // 新增：点击条目处理函数 - 一旦展开就不会隐藏
  const handleItemClick = (id: number) => {
    setSelectedItemIds(
      (prev) =>
        prev.includes(id)
          ? prev // 已经选中，不做任何操作
          : [...prev, id] // 未选中，添加到选中数组
    );
  };

  // 新增：控制列表项显示数量的状态
  const [visibleListCount, setVisibleListCount] = React.useState(1);
  // 新增：是否开始动画的状态
  const [listAnimationStarted1, setListAnimationStarted1] =
    React.useState(false);

  // 新增：点击第一条列表项的处理函数
  const handleFirstItemClick = () => {
    if (!listAnimationStarted1) {
      setListAnimationStarted1(true);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic900-section2-2'
      );
    }
  };

  // const [state, setState] = React.useState({
  //   deepfakeFlagLeft: false,
  //   deepfakeFlagRight: false,
  // });

  React.useEffect(() => {
    if (state.deepfakeFlagRight && state.deepfakeFlagLeft) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic900-section2-0'
      );
    }
  }, [p_course, p_topic, state.deepfakeFlagLeft, state.deepfakeFlagRight]);

  // 新增：用于逐条显示列表项的effect
  React.useEffect(() => {
    if (!listAnimationStarted1 || !paragraphsSettings.list) return;
    if (visibleListCount >= paragraphsSettings.list.length) return;

    const timer = setTimeout(() => {
      setVisibleListCount((prev) => prev + 1);
    }, 400); // 每条间隔400ms显示

    return () => clearTimeout(timer);
  }, [visibleListCount, listAnimationStarted1, paragraphsSettings.list]);

  React.useEffect(() => {
    if (selectedItemIds.length >= 2) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic900-section2-1'
      );
    }
  }, [p_course, p_topic, selectedItemIds]);

  const [visibleCount, setVisibleCount] = React.useState(1); // 默认显示第一条
  const [animationStarted, setAnimationStarted] = React.useState(false); // 控制动画是否已开始
  const [listsVisible, setListsVisible] = React.useState(false); // 控制lists是否可见

  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted) return;
    setAnimationStarted(true);

    // 如果已经显示完所有项目，则停止
    if (visibleCount >= paragraphsSettings.risks?.length) return;

    const timer = setTimeout(() => {
      setVisibleCount((v) => v + 1);
    }, 600);

    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);

  // 点击第一条list项时显示所有列表
  const handleFirstListItemClick = () => {
    if (!listsVisible) {
      setListsVisible(true);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic900-section2-3'
      );
    }
  };

  return (
    <>
      <div className="topic-section-3">
        <div>
          <CTitle title={paragraphsSettings.header} />
          <div
            className="case-study"
            id="cybersecurity2026-topic900-section2-0"
          >
            <div
              className="case-study-left"
              onClick={() => setState({ ...state, deepfakeFlagLeft: true })}
            >
              {!state.deepfakeFlagLeft ? (
                <img src={arrow} alt="" />
              ) : (
                <span className="focus-in-expand-fwd">
                  {paragraphsSettings?.caseStudy1}
                </span>
              )}
            </div>
            <div
              className="case-study-right"
              onClick={() => setState({ ...state, deepfakeFlagRight: true })}
            >
              {!state.deepfakeFlagRight ? (
                <img src={arrow} alt="" />
              ) : (
                <span className="focus-in-expand-fwd">
                  {paragraphsSettings?.caseStudy2}
                </span>
              )}
            </div>
          </div>
          <div
            className="cybersecurity-key-points"
            id="cybersecurity2026-topic900-section2-1"
          >
            <div className="cybersecurity-key-points-tip">
              {paragraphsSettings.tips}
            </div>
            <div className="right-container">
              {paragraphsSettings.listArr?.map((item: any) => (
                <div
                  className={`cybersecurity-key-points-item ${
                    selectedItemIds.includes(item.id) ? 'active' : ''
                  }`}
                  key={item.id}
                  onClick={() => handleItemClick(item.id)}
                >
                  <div className="item-left">
                    <img src={iconMap[item.id]} alt="" />
                    <div
                      className="item-left-text"
                      dangerouslySetInnerHTML={{
                        __html: item?.title,
                      }}
                    ></div>
                    {!selectedItemIds.includes(item.id) && (
                      <img src={arrow} alt="" />
                    )}
                  </div>
                  {selectedItemIds.includes(item.id) && (
                    <div className="item-right">
                      <p>{item.phenomenon}</p>
                      <p>{item.influence}</p>
                      <ul className="impact-list">
                        {item.contents.map((em: string) => (
                          <li key={em}>{em}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div
            className="cybersecurity-root-cause"
            id="cybersecurity2026-topic900-section2-2"
          >
            {!listAnimationStarted1 && <img src={arrow} alt="" />}
            <div className="cybersecurity-root-cause-text">
              <div className="cybersecurity-root-cause-tip">
                <div className="cybersecurity-root-cause-title text-focus-in">
                  {paragraphsSettings.description}
                </div>
              </div>
            </div>
            <div className="cybersecurity-root-cause-img">
              <img src={section3Img2} alt="" />
            </div>
            <div className="cybersecurity-root-cause-list">
              <div className="title-con">
                {paragraphsSettings.listTitle.map((item: string) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
              <div className="list-con">
                {paragraphsSettings.list?.map((item: any, index: number) => (
                  <div
                    className={`list-item ${
                      index < visibleListCount ? 'visible' : ''
                    }`}
                    key={index}
                    onClick={index === 0 ? handleFirstItemClick : undefined}
                  >
                    <span>{item.type}</span>
                    <span>{item.reason}</span>
                    <span>{item.desc}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="topic-section-2">
        <div className="t900_custom">
          <i className="back_piece"></i>
          <STitle title={paragraphsSettings?.header}></STitle>
          <div className="triangle-container">
            <span className="triangle"></span> {paragraphsSettings?.l3tips}
          </div>
          {!listsVisible && <img className="arrow-img" src={arrow} alt="" />}
          <div
            className="overview-network-security"
            id="cybersecurity2026-topic900-section2-3"
          >
            {paragraphsSettings?.lists?.map((item: any, index: number) => (
              <div
                key={index}
                className={`overview-network-security-item overview-network-security-item-${
                  index + 1
                }`}
                style={{
                  opacity: listsVisible || index === 0 ? 1 : 0,
                  transition: 'opacity 0.5s ease',
                }}
                onClick={index === 0 ? handleFirstListItemClick : undefined}
                data-show={listsVisible || index === 0}
              >
                <div className="title-style">{item.title}</div>
                <div
                  className="con"
                  style={{
                    opacity: listsVisible || index === 0 ? 1 : 0,
                    transition: 'opacity 0.5s ease',
                  }}
                >
                  {item.con}
                </div>
              </div>
            ))}
            <div className="dialogue-left">{paragraphsSettings.leftTips}</div>
            <div className="dialogue-right">{paragraphsSettings.rightTips}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section2;
